import { render, staticRenderFns } from "./FormPhoneTooltip.vue?vue&type=template&id=2aca3080&scoped=true"
import script from "./FormPhoneTooltip.vue?vue&type=script&lang=js"
export * from "./FormPhoneTooltip.vue?vue&type=script&lang=js"
import style0 from "./FormPhoneTooltip.vue?vue&type=style&index=0&id=2aca3080&prod&scoped=true&lang=scss"
import style1 from "./FormPhoneTooltip.vue?vue&type=style&index=1&id=2aca3080&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aca3080",
  null
  
)

export default component.exports